/* eslint-disable no-restricted-imports,no-duplicate-imports */
/**
 * Orderopatorio
 *
 * The version of the OpenAPI document: 0.15.6-SNAPSHOT
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import axios, { AxiosRequestConfig, RawAxiosRequestHeaders } from 'axios';
import {
  DUMMY_BASE_URL,
  getBaseUrl,
  setSearchParams,
  toPathString,
} from 'config/apiUtils';
import { UnavailableAtResponse } from '../models';

export const MenusUserAPIApi = {
  getOrderingDeadlines() {
    const localVarRequestOptions: AxiosRequestConfig = { method: 'GET' };

    const localVarUrl = '/user/menus/unavailable-at';
    const localVarUrlObj = new URL(localVarUrl, DUMMY_BASE_URL);
    const localVarHeaderParameter: RawAxiosRequestHeaders = {};
    const localVarQueryParameter: Record<string, any> = {};

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    localVarRequestOptions.headers = { ...localVarHeaderParameter };
    const axiosRequestArgs = {
      ...localVarRequestOptions,
      url: getBaseUrl() + toPathString(localVarUrlObj),
    };
    return axios.request<UnavailableAtResponse>(axiosRequestArgs);
  },
};
